import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { SambaFlow } from "ipctg-inflow-types/InFlowThemes"

import Card from "@/globalComponents/atoms/Card"
import { cleanEmptyParams } from "@/utilities/etc"
import { scopedTo } from "@/utilities/scopedRoutes"

import InflowAuthLogo from "./-components/InflowAuthLogo"

export const Route = createFileRoute("/auth")({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    qrLookupID: string | undefined
    redirect: string | undefined
    plate: string | undefined
    phone: string | undefined
    email: string | undefined
    conversionFlow:
      | `${SambaFlow["type"]}Register`
      | `required${Capitalize<SambaFlow["type"]>}`
      | undefined
  } => {
    return cleanEmptyParams({
      qrLookupID: (search.qrLookupID as string) || undefined,
      redirect: (search.redirect as string) || undefined,
      plate: (search.plate as string) || undefined,
      phone: (search.phone as string) || undefined,
      email: (search.email as string) || undefined,
      conversionFlow:
        search.conversionFlow === "externalRegister" ||
        search.conversionFlow === "flexPurchaseRegister" ||
        search.conversionFlow === "gatedRegister" ||
        search.conversionFlow === "parkRegister" ||
        search.conversionFlow === "reserveRegister" ||
        search.conversionFlow === "unlockInventoryRegister" ||
        search.conversionFlow === "requiredGated" ||
        search.conversionFlow === "requiredPark" ||
        search.conversionFlow === "requiredFlexPurchase" ||
        search.conversionFlow === "requiredReserve" ||
        search.conversionFlow === "requiredUnlockInventory" ||
        search.conversionFlow === "requiredExternal"
          ? search.conversionFlow
          : undefined,
    })
  },
  loaderDeps: ({ search }) => {
    return { qrLookupID: search.qrLookupID }
  },
  beforeLoad: ({ context, search }) => {
    const qrLookupID = search.qrLookupID
    const redirectPath = search.redirect
    if (context.isAuthenticated) {
      if (redirectPath) {
        throw redirect({
          to: redirectPath,
        })
      } else {
        throw redirect(scopedTo("/", qrLookupID))
      }
    }
  },
  loader: ({ context, deps }) => {
    context.setDocumentThemeMode(deps.qrLookupID ? "whiteLabel" : "root")
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Card>
      <InflowAuthLogo />
      <Outlet />
    </Card>
  )
}
